var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "address mb-3",
    "class": {
      'input-style-tailwind': _vm.inputStyle === 'tailwind'
    }
  }, [_vm.title ? _c('h6', {
    "class": _vm.inputStyle === 'tailwind' ? 'text-lg font-semibold mb-4' : 'text-overline font-weight-bold'
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_vm.inputStyle === 'tailwind' ? [_c('div', {
    staticClass: "space-y-1.5"
  }, [_c('label', {
    staticClass: "text-xs font-semibold text-slate-500 uppercase tracking-wider",
    attrs: {
      "for": "address-contact_name-".concat(_vm._uid)
    }
  }, [_vm._v(_vm._s(_vm.$translate('contactname')))]), _c('input', {
    "class": [_vm.twInputClass, _vm.errors.contact_name && _vm.errors.contact_name.length ? 'border-red-500' : ''],
    attrs: {
      "id": "address-contact_name-".concat(_vm._uid),
      "type": "text",
      "placeholder": _vm.$translate('contactnamePlaceholder'),
      "disabled": _vm.readonly
    },
    domProps: {
      "value": _vm.address.contact_name
    },
    on: {
      "input": function input($event) {
        _vm.address.contact_name = $event.target.value;
        _vm.$emit('input', _vm.address);
      }
    }
  }), _vm.errors.contact_name && _vm.errors.contact_name.length ? _c('p', {
    staticClass: "text-xs text-red-600"
  }, [_vm._v(_vm._s(_vm.errors.contact_name[0]))]) : _vm._e()])] : _c('v-text-field', {
    attrs: {
      "error-messages": _vm.errors.contact_name,
      "label": _vm.$translate('contactname'),
      "placeholder": _vm.$translate('contactnamePlaceholder'),
      "disabled": _vm.readonly,
      "dense": true,
      "outlined": _vm.outlined,
      "hide-details": "auto",
      "clearable": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', _vm.address || {});
      }
    },
    model: {
      value: _vm.address.contact_name,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "contact_name", $$v);
      },
      expression: "address.contact_name"
    }
  })], 2), _vm.showEmails ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    "class": [{
      'space-y-1.5': _vm.inputStyle === 'tailwind'
    }, _vm.requiredHintClass(_vm.address.emails)]
  }, [_vm.inputStyle === 'tailwind' ? _c('label', {
    staticClass: "text-xs font-semibold text-slate-500 uppercase tracking-wider block",
    attrs: {
      "for": "address-emails-".concat(_vm._uid)
    }
  }, [_vm._v(_vm._s(_vm.$translate('emails')) + _vm._s(_vm.requiredLabels ? ' *' : ''))]) : _vm._e(), _c('v-combobox', {
    ref: "emails",
    attrs: {
      "id": "address-emails-".concat(_vm._uid),
      "append-icon": null,
      "hide-no-data": "",
      "disabled": _vm.readonly,
      "error-messages": _vm.emailsErrors && _vm.flatEmailsErrors || (_vm.highlightMandatory && (!_vm.address.emails || _vm.address.emails.length === 0) ? [_vm.$translate('required')] : null),
      "hint": _vm.inputStyle !== 'tailwind' ? _vm.$translate('enterEmailAndPressTab') : null,
      "label": _vm.inputStyle === 'tailwind' ? null : _vm.$translate('emails'),
      "placeholder": _vm.fieldPlaceholder('enterEmailAndPressTab', true),
      "persistent-placeholder": _vm.showPersistentRequiredHint(true),
      "value": _vm.address.emails,
      "clearable": "",
      "deletable-chips": "",
      "dense": "",
      "outlined": _vm.outlined,
      "multiple": "",
      "hide-details": "auto"
    },
    on: {
      "input": function input($event) {
        return _vm.setEmails($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          item = _ref.item,
          select = _ref.select,
          selected = _ref.selected;
        return [_c('v-chip', _vm._b({
          staticClass: "mx-1 primary-lighter3",
          attrs: {
            "input-value": selected,
            "close": "",
            "small": "",
            "hide-details": "auto"
          },
          on: {
            "click": select,
            "click:close": function clickClose($event) {
              return _vm.removeEmail(item);
            }
          }
        }, 'v-chip', attrs, false), [_vm._v(" " + _vm._s(item) + " ")])];
      }
    }], null, false, 3851122997)
  })], 1)]) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    "class": [{
      'space-y-1.5': _vm.inputStyle === 'tailwind'
    }, _vm.requiredHintClass(_vm.address.line1)]
  }, [_vm.inputStyle === 'tailwind' ? _c('label', {
    staticClass: "text-xs font-semibold text-slate-500 uppercase tracking-wider block",
    attrs: {
      "for": "address-line1-".concat(_vm._uid)
    }
  }, [_vm._v(_vm._s(_vm.$translate('address')) + _vm._s(_vm.requiredLabels ? ' *' : ''))]) : _vm._e(), _c('GoogleAddressAutocomplete', {
    attrs: {
      "input-id": "address-line1-".concat(_vm._uid),
      "error-messages": _vm.errors.line1 || (_vm.highlightMandatory && !_vm.address.line1 ? [_vm.$translate('required')] : null),
      "label": _vm.inputStyle === 'tailwind' ? null : _vm.$translate('address'),
      "placeholder": _vm.fieldPlaceholder('addressPlaceholder', true),
      "persistent-placeholder": _vm.showPersistentRequiredHint(true),
      "placeholder-hint-active": _vm.showRequiredIndicators && !_vm.address.line1,
      "disabled": _vm.readonly,
      "dense": true,
      "outlined": _vm.outlined,
      "input-style": _vm.inputStyle,
      "hide-details": "auto"
    },
    on: {
      "address-selected": _vm.handleAddressSelected,
      "input": function input($event) {
        return _vm.$emit('input', _vm.address || {});
      }
    },
    model: {
      value: _vm.address.line1,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "line1", $$v);
      },
      expression: "address.line1"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_vm.inputStyle === 'tailwind' ? [_c('div', {
    staticClass: "space-y-1.5"
  }, [_c('label', {
    staticClass: "text-xs font-semibold text-slate-500 uppercase tracking-wider",
    attrs: {
      "for": "address-line2-".concat(_vm._uid)
    }
  }, [_vm._v(_vm._s(_vm.$translate('addressLine2')))]), _c('input', {
    "class": [_vm.twInputClass, _vm.errors.line2 && _vm.errors.line2.length ? 'border-red-500' : ''],
    attrs: {
      "id": "address-line2-".concat(_vm._uid),
      "type": "text",
      "placeholder": _vm.$translate('addressLine2Placeholder'),
      "disabled": _vm.readonly
    },
    domProps: {
      "value": _vm.address.line2
    },
    on: {
      "input": function input($event) {
        _vm.address.line2 = $event.target.value;
        _vm.$emit('input', _vm.address);
      }
    }
  }), _vm.errors.line2 && _vm.errors.line2.length ? _c('p', {
    staticClass: "text-xs text-red-600"
  }, [_vm._v(_vm._s(_vm.errors.line2[0]))]) : _vm._e()])] : _c('v-text-field', {
    attrs: {
      "error-messages": _vm.errors.line2,
      "label": _vm.$translate('addressLine2'),
      "placeholder": _vm.$translate('addressLine2Placeholder'),
      "disabled": _vm.readonly,
      "dense": true,
      "outlined": _vm.outlined,
      "hide-details": "auto",
      "clearable": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', _vm.address || {});
      }
    },
    model: {
      value: _vm.address.line2,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "line2", $$v);
      },
      expression: "address.line2"
    }
  })], 2), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_vm.inputStyle === 'tailwind' ? [_c('div', {
    "class": ['space-y-1.5', _vm.requiredHintClass(_vm.address.city)]
  }, [_c('label', {
    staticClass: "text-xs font-semibold text-slate-500 uppercase tracking-wider",
    attrs: {
      "for": "address-city-".concat(_vm._uid)
    }
  }, [_vm._v(_vm._s(_vm.$translate('city')) + _vm._s(_vm.requiredLabels ? ' *' : ''))]), _c('input', {
    "class": [_vm.twInputClass, _vm.errors.city && _vm.errors.city.length || _vm.highlightMandatory && !_vm.address.city ? 'border-red-500' : ''],
    attrs: {
      "id": "address-city-".concat(_vm._uid),
      "type": "text",
      "placeholder": _vm.fieldPlaceholder('cityPlaceholder', true),
      "disabled": _vm.readonly
    },
    domProps: {
      "value": _vm.address.city
    },
    on: {
      "input": function input($event) {
        _vm.address.city = $event.target.value;
        _vm.$emit('input', _vm.address);
      }
    }
  }), _vm.errors.city && _vm.errors.city.length || _vm.highlightMandatory && !_vm.address.city ? _c('p', {
    staticClass: "text-xs text-red-600"
  }, [_vm._v(_vm._s(_vm.errors.city && _vm.errors.city[0] || _vm.$translate('required')))]) : _vm._e()])] : _c('v-text-field', {
    "class": _vm.requiredHintClass(_vm.address.city),
    attrs: {
      "error-messages": _vm.errors.city || (_vm.highlightMandatory && !_vm.address.city ? [_vm.$translate('required')] : null),
      "label": _vm.$translate('city'),
      "placeholder": _vm.fieldPlaceholder('cityPlaceholder', true),
      "persistent-placeholder": _vm.showPersistentRequiredHint(true),
      "disabled": _vm.readonly,
      "hide-details": "auto",
      "dense": true,
      "outlined": _vm.outlined,
      "clearable": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', _vm.address || {});
      }
    },
    model: {
      value: _vm.address.city,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "city", $$v);
      },
      expression: "address.city"
    }
  })], 2), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_vm.inputStyle === 'tailwind' ? [_c('div', {
    "class": ['space-y-1.5', _vm.requiredHintClass(_vm.address.postal_code)]
  }, [_c('label', {
    staticClass: "text-xs font-semibold text-slate-500 uppercase tracking-wider",
    attrs: {
      "for": "address-postal_code-".concat(_vm._uid)
    }
  }, [_vm._v(_vm._s(_vm.$translate('postalCode')) + _vm._s(_vm.requiredLabels ? ' *' : ''))]), _c('input', {
    "class": [_vm.twInputClass, _vm.errors.postal_code && _vm.errors.postal_code.length || _vm.highlightMandatory && !_vm.address.postal_code ? 'border-red-500' : ''],
    attrs: {
      "id": "address-postal_code-".concat(_vm._uid),
      "type": "text",
      "placeholder": _vm.fieldPlaceholder('postalCodePlaceholder', true),
      "disabled": _vm.readonly
    },
    domProps: {
      "value": _vm.address.postal_code
    },
    on: {
      "input": function input($event) {
        _vm.address.postal_code = $event.target.value;
        _vm.$emit('input', _vm.address);
      }
    }
  }), _vm.errors.postal_code && _vm.errors.postal_code.length || _vm.highlightMandatory && !_vm.address.postal_code ? _c('p', {
    staticClass: "text-xs text-red-600"
  }, [_vm._v(_vm._s(_vm.errors.postal_code && _vm.errors.postal_code[0] || _vm.$translate('required')))]) : _vm._e()])] : _c('v-text-field', {
    "class": _vm.requiredHintClass(_vm.address.postal_code),
    attrs: {
      "error-messages": _vm.errors.postal_code || (_vm.highlightMandatory && !_vm.address.postal_code ? [_vm.$translate('required')] : null),
      "label": _vm.$translate('postalCode'),
      "placeholder": _vm.fieldPlaceholder('postalCodePlaceholder', true),
      "persistent-placeholder": _vm.showPersistentRequiredHint(true),
      "disabled": _vm.readonly,
      "dense": true,
      "outlined": _vm.outlined,
      "hide-details": "auto",
      "clearable": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', _vm.address || {});
      }
    },
    model: {
      value: _vm.address.postal_code,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "postal_code", $$v);
      },
      expression: "address.postal_code"
    }
  })], 2), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('div', {
    "class": [{
      'space-y-1.5': _vm.inputStyle === 'tailwind'
    }, _vm.requiredHintClass(_vm.address.country)]
  }, [_vm.inputStyle === 'tailwind' ? _c('label', {
    staticClass: "text-xs font-semibold text-slate-500 uppercase tracking-wider block",
    attrs: {
      "for": "address-country-".concat(_vm._uid)
    }
  }, [_vm._v(_vm._s(_vm.$translate('country')) + _vm._s(_vm.requiredLabels ? ' *' : ''))]) : _vm._e(), _c('CountrySelect', {
    attrs: {
      "input-id": "address-country-".concat(_vm._uid),
      "value": _vm.address.country,
      "error-messages": _vm.errors.country || (_vm.highlightMandatory && !_vm.address.country ? [_vm.$translate('required')] : null),
      "label": _vm.inputStyle === 'tailwind' ? null : _vm.$translate('country'),
      "placeholder": _vm.fieldPlaceholder('countryPlaceholder', true),
      "persistent-placeholder": _vm.showPersistentRequiredHint(true),
      "disabled": _vm.readonly,
      "dense": true,
      "outlined": _vm.outlined,
      "input-style": _vm.inputStyle,
      "hide-details": "auto"
    },
    on: {
      "input": _vm.updateCountry
    }
  }), _vm.inputStyle === 'tailwind' && (_vm.errors.country && _vm.errors.country.length || _vm.highlightMandatory && !_vm.address.country) ? _c('p', {
    staticClass: "text-xs text-red-600"
  }, [_vm._v(_vm._s(_vm.errors.country && _vm.errors.country[0] || _vm.$translate('required')))]) : _vm._e()], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    "class": {
      'address-phone-field space-y-1.5': _vm.inputStyle === 'tailwind'
    }
  }, [_vm.inputStyle === 'tailwind' || _vm.showPhoneLabels ? _c('label', {
    staticClass: "text-xs font-semibold text-slate-500 uppercase tracking-wider block",
    attrs: {
      "for": "address-mobile-".concat(_vm._uid)
    }
  }, [_vm._v(_vm._s(_vm.$translate('mobileNumber')))]) : _vm._e(), _c('vue-tel-input', {
    key: _vm.address.country,
    "class": {
      'error--text': _vm.mobilePhoneNumberErrors
    },
    attrs: {
      "auto-default-country": false,
      "value": _vm.address.mobile_phone_number || '',
      "disabled": _vm.readonly,
      "defaultCountry": _vm.defaultCountryCode,
      "inputOptions": {
        id: "address-mobile-".concat(_vm._uid),
        placeholder: _vm.$translate('mobileNumber'),
        showDialCode: false
      },
      "validCharactersOnly": true,
      "mode": "international"
    },
    on: {
      "input": _vm.updateMobilePhoneNumber,
      "validate": _vm.validateMobilePhoneNumber
    }
  }), _vm.mobilePhoneNumberErrors && _vm.mobilePhoneNumberErrors.length ? _c('p', {
    staticClass: "text-xs text-red-600"
  }, [_vm._v(_vm._s(_vm.mobilePhoneNumberErrors[0]))]) : _vm._e()], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    "class": {
      'address-phone-field space-y-1.5': _vm.inputStyle === 'tailwind'
    }
  }, [_vm.inputStyle === 'tailwind' || _vm.showPhoneLabels ? _c('label', {
    staticClass: "text-xs font-semibold text-slate-500 uppercase tracking-wider block",
    attrs: {
      "for": "address-phone-".concat(_vm._uid)
    }
  }, [_vm._v(_vm._s(_vm.$translate('phoneNumber')))]) : _vm._e(), _c('vue-tel-input', {
    key: _vm.defaultCountryCode,
    "class": {
      'error--text': _vm.phoneNumberErrors
    },
    attrs: {
      "auto-default-country": false,
      "value": _vm.address.phone_number || '',
      "disabled": _vm.readonly,
      "default-country": _vm.defaultCountryCode,
      "input-options": {
        id: "address-phone-".concat(_vm._uid),
        placeholder: _vm.$translate('phoneNumber'),
        showDialCode: false
      },
      "valid-characters-only": true,
      "mode": "international"
    },
    on: {
      "input": _vm.updatePhoneNumber,
      "validate": _vm.validatePhoneNumber
    }
  }), _vm.phoneNumberErrors && _vm.phoneNumberErrors.length ? _c('p', {
    staticClass: "text-xs text-red-600"
  }, [_vm._v(_vm._s(_vm.phoneNumberErrors[0]))]) : _vm._e()], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }